import React from "react"
import {Link} from 'gatsby'

const Breadcrumb = (props) => (

    <nav aria-label="breadcrumb">
        <div className="container">
            <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/">Hjem</Link></li>
                <li className="breadcrumb-item"><Link to={props.archiveLink}>{props.archive}</Link></li>
                <li className="breadcrumb-item active" aria-current="page">{props.title}</li>
            </ol>
        </div>
    </nav>

    )


export default Breadcrumb;